import FirmOfficesView from "@/components/features/settings/firm-offices/FirmOfficesView";
import { Text } from "@/components/ui";
import { serverErrorFallbackText } from "@/lib/data/static/fallbackMessages";
import { ErrorBoundary } from "@sentry/react";

export default function FirmOfficesCard() {
  return (
    <div className="w-full" data-testid="firm-offices-card">
      <div className="mb-8 gap-y-1">
        <Text variant="title">Offices</Text>
      </div>
      <ErrorBoundary fallback={<div>{serverErrorFallbackText}</div>}>
        <FirmOfficesView />
      </ErrorBoundary>
    </div>
  );
}
